import { obDefaultValGet } from '../common/common';

export default class User {
    constructor(initOb=null) {
        this.id = obDefaultValGet(initOb, 'id', ''); 
        this.playerName = obDefaultValGet(initOb, 'playerName', ''); 
        this.accountProvider = obDefaultValGet(initOb, 'accountProvider', ''); 
    }
}